<template>
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/chatBot">ChatBot</router-link> |
    <router-link to="/furniture-game">Furnish Game</router-link> |
    <router-link to="/stories">Stories</router-link> |
    <router-link to="/dataCenter">DataCenter</router-link>
  </div>
</template>

<style>
#nav {
  position: absolute;
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
